import { BAIDU_MAP_AK } from '../../../../../../../constant/constant.js'

export default function loadBMap() {
    return new Promise(function(resolve, reject) {
        if (typeof BMap !== 'undefined') {
            // eslint-disable-next-line
            resolve(BMap);
            return;
        }
        window.onBMapCallback = function() {
            // eslint-disable-next-line
            resolve(BMap);
        };
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://api.map.baidu.com/api?v=3.0&ak=' + BAIDU_MAP_AK + '&callback=onBMapCallback';
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
